import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SIBASI_APPS } from './common/model/sibasi-system.model';
import {
  ConnectionStatusEnum,
  NetworkConnection
} from './common/modules/network/network-connection';
import { LoaderService } from './common/services/loader/loader.service';
// declare global {
//     interface Navigator {
//         app: {
//             exitApp: () => void;
//         };
//     }
// }

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [MessageService]
})
export class AppComponent implements OnInit, OnDestroy {
  readonly primengConfig = inject(PrimeNGConfig);
  readonly loaderService = inject(LoaderService);
  readonly messageService = inject(MessageService);

  isOffline = false;
  subscriptions = new Subscription();

  constructor() {
    NetworkConnection.init();
    // this.initializeApp();
  }
  //mobile app
  // initializeApp() {
  //     this.platform.ready().then(() => {
  //         this.handleBackButton();
  //     });
  // }
  // handleBackButton() {
  //     this.platform.backButton.subscribeWithPriority(10, () => {
  //         if (this.router.url === '') {
  //             navigator['app'].exitApp();
  //         } else {
  //             this.location.back();
  //         }
  //     });
  // }
  // toggleMenu() {
  //     this.menuCtrl.toggle();
  //   }

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.checkNetworkConnection();
    this.changeFavicon();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  checkNetworkConnection(): void {
    NetworkConnection.online$.subscribe({
      next: () => {
        this.isOffline = false;
        NetworkConnection.status = ConnectionStatusEnum.Online;
        this.showInternetConnectionModal(this.isOffline);
      }
    });

    NetworkConnection.offline$.subscribe({
      next: () => {
        this.isOffline = true;
        NetworkConnection.status = ConnectionStatusEnum.Offline;
        this.showInternetConnectionModal(this.isOffline);
      }
    });
  }

  showInternetConnectionModal(isOffline: boolean): void {
    if (isOffline) {
      this.messageService.add({
        key: 'confirm',
        sticky: true,
        severity: 'custom',
        summary: 'Uploading your files.'
      });
    } else {
      this.messageService.clear();
    }
  }

  onClose(): void {
    this.isOffline = false;
  }

  changeFavicon(): void {
    const faviconLink: HTMLLinkElement | null = document.querySelector('#favicon');
    if (faviconLink) {
      switch (environment.activeApp) {
        case SIBASI_APPS.EBOARD:
          faviconLink.href = 'assets/favicon/default-favicon.ico';
          break;
        case SIBASI_APPS.MONIVAL:
          faviconLink.href = 'assets/favicon/monival-favicon.ico';
          break;
        case SIBASI_APPS.EBMSUITE:
          faviconLink.href = 'assets/favicon/ebmsuite-favicon.ico';
          break;
        default:
          faviconLink.href = 'assets/favicon/default-favicon.ico';
          break;
      }
    }
  }
}

if (typeof Worker !== 'undefined') {
  // Create a new
  const worker = new Worker(new URL('./app.worker', import.meta.url));
  worker.onmessage = ({ data }) => {
    console.log(`page got message: ${data}`);
  };
  worker.postMessage('hello');
} else {
  // Web Workers are not supported in this environment.
  // You should add a fallback so that your program still executes correctly.
}
